




























import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/firestore";

import { Furniture } from "@/data/Furniture";
import { Approvals } from "@/data/Sample";

@Component
export default class AdminDialog extends Vue {
  dialog = false;

  sampleData: Furniture[] = Approvals;

  @Prop()
  collection!: string;

  addTo(col: string): void {
    this.dialog = false;
    const collection = firebase.firestore().collection(col);
    this.sampleData.forEach((data) => {
      const update = data;
      const dataRef = collection.doc();
      update.id = dataRef.id;
      update.timing.dateAdded = new Date();
      dataRef.set(data);
    });
  }
}
